/**
 * Shared FO2026 diary / async loading markup (matches Snippets/preloader.twig).
 */
export default class JPPreloader
{
	/**
	 * @param {string} [label]
	 * @param {{ compact?: boolean, inline?: boolean, showLabel?: boolean, extraClass?: string, attrs?: string }} [options]
	 */
	static html(label = "Načítám…", options = {})
	{
		const compact = Boolean(options.compact);
		const inline = Boolean(options.inline);
		const showLabel = options.showLabel != null ? Boolean(options.showLabel) : !inline;
		const extraClass = options.extraClass ? ` ${options.extraClass}` : "";
		const attrs = options.attrs ? ` ${options.attrs}` : "";
		const modifiers = [
			compact ? " jp-preloader--compact" : "",
			inline ? " jp-preloader--inline" : "",
		].join("");

		const labelHtml = showLabel && label
			? `<span class="jp-preloader__label">${label}</span>`
			: "";

		return `<div class="jp-preloader${modifiers}${extraClass}" role="status" aria-live="polite" aria-busy="true"${attrs}>
			<span class="jp-preloader__dots" aria-hidden="true"><span></span><span></span><span></span></span>
			${labelHtml}
		</div>`;
	}

	/**
	 * @param {HTMLElement|null} button
	 */
	static attachToButton(button)
	{
		if (!button || button.querySelector(".jp-button__loader")) {
			return;
		}
		button.classList.add("is-busy");
		button.setAttribute("aria-busy", "true");
		button.insertAdjacentHTML("beforeend", JPPreloader.html("", {
			compact: true,
			showLabel: false,
			extraClass: "jp-button__loader",
		}));
	}

	/**
	 * @param {HTMLElement|null} button
	 */
	static detachFromButton(button)
	{
		if (!button) {
			return;
		}
		button.classList.remove("is-busy");
		button.removeAttribute("aria-busy");
		const loader = button.querySelector(".jp-button__loader");
		if (loader) {
			loader.remove();
		}
	}
}
